import Form, { AIAssistantFormMode } from "./Form";
import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import GenericDialog from "../GenericDialog";

export default function Edit({ open, setOpen, entry, onEdit }) {
  const { homeState, homeDispatch } = useContext(HomeAppContext);

  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);
  const [readOnly, setReadOnly] = useState(false);

  React.useEffect(() => {
    if (entry !== null && open) {
      setLoading(true);
      setReadOnly((entry.createdBy !== homeState.userProfile.userId) && (entry.shareType === 1));
      homeDispatch({
        type: "NOTIFICATION",
        data: { message: "Fetching assistant details", loading: true }
      });
      api
        .get(`/api/ai-assistants/${entry.id}`)
        .then((r) => {
          homeDispatch({
            type: "NOTIFICATION",
            data: {
              message: "Assistant details fetched successfuly",
              type: "success"
            }
          });
          setInternalEntry({
            ...r.data,
            deployment: {
              id: entry.model,
              name: entry.model
            },
            assistantFiles: r.data.assistantFiles
          });
        })
        .catch((error) => {
          errorManagement.formErrors(error, homeDispatch);
        })
        .finally(() => {
          setErrors([]);
          setSubmitted(false);
          setLoading(false);
        });
    } else {
      setInternalEntry(null);
    }
  }, [entry, open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleCloseSave = () => {
    if (readOnly) return;
    const updateAssistant = {
      id: internalEntry.id,
      model:
        internalEntry.deployment?.id !== undefined
          ? internalEntry.deployment.id
          : internalEntry.model,
      files: [
        ...internalEntry.files?.map((f) => ({
          fileId: f.fileId,
          name: f.name
        })),
        ...internalEntry.assistantFiles?.map((f) => ({
          fileId: -1,
          id: f.id,
          name: f.filename
        }))
      ],
      instructions: internalEntry.instructions,
      description: internalEntry.description,
      name: internalEntry.name,
      codeInterpreter: internalEntry.codeInterpreter
    };

    console.log(internalEntry);
    console.log(updateAssistant);

    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Updating " + internalEntry.name, loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    api
      .put(`/api/ai-assistants/${updateAssistant.id}`, updateAssistant)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: internalEntry.name + " updated",
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        onEdit();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
     <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {(!readOnly) && (          
        <Button
          onClick={handleCloseSave}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
        Save Assistant
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      title={readOnly ? "View AI Assistant" : "Edit AI Assistant"}
      actions={actions}
    >
      {readOnly && (
          <Box
            sx={{
              padding: 2,
              border: "1px solid",
              borderColor: "warning.main",
              borderRadius: "8px",
              backgroundColor: "warning.mainlight",
              marginBottom: 2,
              color: "warning.dark",
              textAlign: "center"
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              This assistant is public read-only, so you cannot edit it.
            </Typography>
          </Box>
        )}
        <Form
          mode={AIAssistantFormMode.EDIT}
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
          readOnly={readOnly}
        />
    </GenericDialog>
  );
}
